import React, { useState, useEffect } from "react";
import { Menu, Avatar, Badge } from "antd";
import axios from 'axios';
import { useNavigate } from 'react-router-dom';
import { UserOutlined, LoginOutlined, LogoutOutlined, BarsOutlined, ShoppingOutlined } from "@ant-design/icons";
import { Link } from "react-router-dom";

const RightMenu = ({ mode }) => {
  const navigate = useNavigate();
  const [cartItemCount, setCartItemCount] = useState(0);
  const [isLoggedIn, setIsLoggedIn] = useState(false);

  const checkAuthStatus = () => {
    const token = localStorage.getItem('access_token');
    setIsLoggedIn(!!token && token !== "");
  };

  const calculateCartItemCount = () => {
    // Count designed orders
    const designedOrders = JSON.parse(localStorage.getItem('designedOrders')) || [];
    const designedCount = designedOrders.reduce((total, order) => total + (order.Amount || 1), 0);
    
    // Count regular cart items
    const regularCart = JSON.parse(localStorage.getItem('cart')) || [];
    const regularCount = regularCart.reduce((total, item) => total + (item.quantity || 1), 0);
    
    return designedCount + regularCount;
  };

  const updateCartCount = () => {
    const count = calculateCartItemCount();
    setCartItemCount(count);
  };

  useEffect(() => {
    // Initial load
    checkAuthStatus();
    updateCartCount();
    
    // Listen for storage changes (when cart is updated from other tabs/windows)
    window.addEventListener('storage', () => {
      updateCartCount();
      checkAuthStatus();
    });
    
    // Custom event for cart updates within the same tab
    window.addEventListener('cartUpdated', updateCartCount);
    
    // Custom event for login/logout
    window.addEventListener('authChanged', checkAuthStatus);
    
    // Interval as fallback (every 2 seconds)
    const interval = setInterval(() => {
      updateCartCount();
      checkAuthStatus();
    }, 2000);
    
    return () => {
      window.removeEventListener('storage', updateCartCount);
      window.removeEventListener('cartUpdated', updateCartCount);
      window.removeEventListener('authChanged', checkAuthStatus);
      clearInterval(interval);
    };
  }, []);

  const LogOut = () => {
    localStorage.setItem('access_token', "");
    localStorage.setItem('refresh_token', "");
    axios.defaults.headers.common['Authorization'] = "";
    setIsLoggedIn(false);
    window.dispatchEvent(new Event('authChanged'));
    navigate("/");
  }

  return (
    <Menu style={{ direction: "ltr" }} className="fEstedad-bold" mode={mode}>
      <Menu.SubMenu
        title={
          <>
            <Avatar icon={<UserOutlined />} />
          </>
        }
      >
        {!isLoggedIn ? (
          <Menu.Item className="fEstedad-bold" style={{ color: "#a23854" }} key="loginSignup">
            <Link to="/login-signup">
              <LoginOutlined style={{ marginLeft: "10px", color: "black" }} /> ورود / ثبت نام
            </Link>
          </Menu.Item>
        ) : (
          <>
            <Menu.Item className="fEstedad-bold" style={{ color: "#a23854" }} key="userDashboard">
              <Link to="/user-dashboard">
                <UserOutlined style={{ marginLeft: "10px", color: "black" }} /> حساب کاربری و سفارشات
              </Link>
            </Menu.Item>
            <Menu.Item onClick={LogOut} className="fEstedad-bold" style={{ color: "#a23854" }} key="log-out">
              <LogoutOutlined style={{ marginLeft: "10px", color: "black" }} /> خروج
            </Menu.Item>
          </>
        )}
      </Menu.SubMenu>

      <Menu.SubMenu
        style={{ paddingTop: '6px' }}
        title={
          <>
            <Badge 
              color="#a23854" 
              offset={[1, 1]} 
              count={cartItemCount}
              style={{ backgroundColor: '#a23854' }}
            >
              <ShoppingOutlined style={{ fontSize: "28px" }} />
            </Badge>
          </>
        }
      >
        <Menu.Item className="fEstedad-bold" style={{ color: "#a23854" }} key="Cart">
          <Link to="/cart">
            <ShoppingOutlined style={{ marginLeft: "10px", color: "black" }} /> سبد خرید
          </Link>
        </Menu.Item>
      </Menu.SubMenu>
    </Menu>
  );
};

export default RightMenu;